module.exports = __webpack_public_path__ + "img/2-1.d73c09fd.svg";